"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDataUrlFromFile = void 0;
const getDataUrlFromFile = (file) => {
    return new Promise(resolve => {
        const fr = new FileReader();
        fr.addEventListener("load", () => {
            resolve(fr.result.toString());
        }, { once: true });
        fr.readAsDataURL(file);
    });
};
exports.getDataUrlFromFile = getDataUrlFromFile;
//# sourceMappingURL=getDataUrlFromFile.js.map